module.exports = __webpack_public_path__ + "img/5.c30c0d74.jpg";